import * as types from '../mutaion-types';

export default {
	namespaced: true,

	state: {
		articles: [],
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/articles').then((response) => {
				commit(types.STORE_ARTICLES, response.data);
				return response.data;
			});
		},

		fetchById({ commit }, { id }) {
			var ar, en;
			return Promise.all([
				axios
					.get(`/articles/${id}`, {
						headers: {
							'Accept-Language': 'ar',
						},
					})
					.then((response) => {
						ar = response.data;
					}),
				axios
					.get(`/articles/${id}`, {
						headers: {
							'Accept-Language': 'en',
						},
					})
					.then((response) => {
						en = response.data;
					}),
			]).then(() => {
				// var keys = Object.keys(ar);
				// var article = {};
				// keys.forEach((key) => {
				//     if (ar[key] === en[key]) {
				//         article[key] = ar[key];
				//     }
				//     else {
				//         article[key] = { ar: ar[key], en: en[key] };
				//     }
				// })
				return { ar, en };
			});
		},

		search(_, { search, page }) {
			return axios
				.get('/articles/article-search', { params: { description: search, page: page } })
				.then((res) => {
					return res.data;
				});
		},
		advanceSearch(_, { set, issn, startDate, endDate, category, keyword, publisher, product, page }) {
			return axios
				.get('/articles/advanced-search', {
					params: { set, issn, startDate, endDate, category, keyword, publisher, product, page },
				})
				.then((res) => {
					return res.data;
				});
		},

		// search({ commit }, { search, set, issn, startDate, endDate, category, keyword, publisher, product }){
		//     var advancedSearch = [];
		//     var globalSearch = [];
		//     var params = { set, issn, startDate, endDate, category, keyword, publisher, product }
		//     var query = {};
		//     Object.keys(params).forEach(param => {
		//         if (params[param]){
		//             query[param] = params[param];
		//         }
		//     });

		//     return Promise.all([
		//         /** if query -Object.keys not empty array- is not empty then it is advance search */
		//         Object.keys(query).length > 0
		//         ? axios.get('/articles/advanced-search', {
		//             params: query
		//         })
		//         .then((response) => {
		//             advancedSearch = response.data;
		//         })
		//         : null,

		//         /** if search is not empty then it is global search */
		//         search
		//         ? axios.get('/articles/article-search', { params:{ description: search } })
		//         .then((response) => {
		//             globalSearch = response.data;
		//         })
		//         : null
		//     ])
		//     .then(() => {
		//         var arr = [advancedSearch, globalSearch].flat();
		//         return (
		//             /**
		//              * if query and search is not empty then should to return
		//              * the shared results between advancedSearch and globalSearch
		//              * else return arr
		//              */
		//             Object.keys(query).length > 0 && search
		//             ? arr.filter((e, i) => arr.findIndex(a => a.id === e.id) !== i)
		//             : arr
		//         );
		//     })
		// }
	},

	mutations: {
		[types.STORE_ARTICLES](state, articles) {
			state.articles = articles;
		},
	},

	getters: {
		getArticleById: (state) => (id) => state.articles.find((c) => c.id === id),
	},
};
